<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <div class="wf-radio-group">
            <label
                v-for="(option, index) in options"
                :key="index"
                class="wf-radio-item"
                :class="{ 'is-selected': value === option }"
            >
                <input
                    type="radio"
                    :name="'radio-' + attribute.id"
                    :value="option"
                    :checked="value === option"
                    @change="emitValue(option)"
                />
                <span class="wf-radio-label">{{ option }}</span>
            </label>
        </div>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'

export default {
    name: 'RadioField',
    mixins: [FieldMixin],
    computed: {
        options() {
            if (!this.attribute.config || !this.attribute.config.options) return []
            return this.attribute.config.options[this.locale] || this.attribute.config.options['fr'] || []
        }
    }
}
</script>
